import { Box } from "@mui/material";
import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { UPDATE_ARTIFACT_LOG_LANGUAGE } from "../../../graphql/mutation/mutation";
import { useVerification } from "../../../context/Verification.context";
import Theme from "../../../utils/Theme";

const ServiceToggle = ({ language, setLanguage, text, setText }) => {
  const verification = useVerification();
  const [languageOpen, setLanguageOpen] = useState(false);
  const [modeOpen, setModeOpen] = useState(false);

  // Add mutation for updating language
  const [updateArtifactLogLanguage] = useMutation(UPDATE_ARTIFACT_LOG_LANGUAGE, {
    onCompleted: (data) => {
      console.log("Language updated in artifact log", data);
    },
    onError: (err) => {
      console.error("Error updating artifact log language", err);
    },
  });

  // Helper function to handle language change with API call
  const handleLanguageChange = (newLanguage) => {
    const isSpanish = newLanguage === "spanish";
    setLanguage(newLanguage);
    
    // Update verification context if available
    if (verification?.setAIData) {
      verification.setAIData((prev) => ({
        ...prev,
        spanish: isSpanish,
        isLoading: true,
      }));
    }

    console.log("verification object 👉", verification);
    console.log("FINAL PAYLOAD", {
      dealership_id: Number(verification?.dealershipId),
      employee_user_id: Number(verification?.employeeId),
      user_id: Number(verification?.customer?.userId),
      language_id: isSpanish ? 2 : 1,
      updated_by: Number(verification?.employeeId),
    });
    
    // Call backend to persist language_id (1 = English, 2 = Spanish)
    updateArtifactLogLanguage({
      variables: {
        updateArtifactLogLanguageInput: {
          dealership_id: Number(verification?.dealershipId),
          employee_user_id: Number(verification?.employeeId),
          user_id: Number(verification?.customer?.userId),
          language_id: isSpanish ? 2 : 1,
          updated_by: Number(verification?.employeeId),
        },
      },
    });
  };

  const dropdownButtonStyles = {
    padding: "13px 7px",
    fontSize: window.innerWidth <= 750 ? "10px" : "12px",
    cursor: "pointer",
    color: Theme.palette.primary.main,
    fontWeight: 500,
    width: window.innerWidth <= 750 ? "70px" : "80px",
    height: window.innerWidth <= 750 ? "32px" : "36px",
    display: "flex",
    alignItems: "center",
    position: "relative",
    justifyContent: "space-between",
  };

  const dropdownContentStyles = {
    position: "absolute",
    top: "100%",
    left: "0%",
    backgroundColor: "#fff",
    width: "100%",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
    zIndex: 1000,
    borderRadius: "4px",
    border: "1px solid #ddd",
    marginTop: "4px",
    overflow: "hidden",
  };

  const dropdownItemStyles = {
    padding: "10px 12px",
    cursor: "pointer",
    fontSize: window.innerWidth <= 750 ? "10px" : "12px",
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  };

  const selectedItemStyles = {
    ...dropdownItemStyles,
    backgroundColor: "#defae5ff",
    fontWeight: 600,
    color: Theme.palette.primary.main,
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {/* Language Dropdown */}
      <Box sx={{ position: "relative" }}>
        <Box
          sx={dropdownButtonStyles}
          onClick={() => {
            setLanguageOpen(!languageOpen);
            setModeOpen(false);
          }}
        >
          {language === "spanish" ? "SPANISH" : "ENGLISH"}
          <span>▼</span>
        </Box>

        {languageOpen && (
          <Box sx={dropdownContentStyles}>
            <Box
              sx={
                language !== "spanish"
                  ? selectedItemStyles
                  : dropdownItemStyles
              }
              onClick={() => {
                handleLanguageChange("english");
                setLanguageOpen(false);
              }}
            >
              ENGLISH
            </Box>
            <Box
              sx={
                language === "spanish"
                  ? selectedItemStyles
                  : dropdownItemStyles
              }
              onClick={() => {
                handleLanguageChange("spanish");
                setLanguageOpen(false);
              }}
            >
              SPANISH
            </Box>
          </Box>
        )}
      </Box>

      {/* Mode Dropdown */}
      <Box sx={{ position: "relative" }}>
        <Box
          sx={dropdownButtonStyles}
          onClick={() => {
            setModeOpen(!modeOpen);
            setLanguageOpen(false);
          }}
        >
          {text ? "READ" : "AVATAR"}
          <span>▼</span>
        </Box>

        {modeOpen && (
          <Box sx={dropdownContentStyles}>
            <Box
              sx={!text ? selectedItemStyles : dropdownItemStyles}
              onClick={() => {
                setText(false);
                setModeOpen(false);
              }}
            >
              AVATAR
            </Box>
            <Box
              sx={text ? selectedItemStyles : dropdownItemStyles}
              onClick={() => {
                setText(true);
                setModeOpen(false);
              }}
            >
              READ
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ServiceToggle;